module.exports = __webpack_public_path__ + "static/bosch-8e7065e398b08cda4cfeb7cb6db30162.jpg";